import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from "@/lib/utils"

const Tabs = TabsPrimitive.Root

const TabsList = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    // max-w-full + overflow-x-auto make the tab bar degrade gracefully when the
    // tabs exceed the available width: instead of clipping the rightmost tabs
    // (and pushing the page wider than the viewport), the list stays within its
    // parent and scrolls horizontally. overflow-y-hidden pins the vertical axis
    // so the horizontal scrollbar (reserved inside the fixed h-9 height) does not
    // trigger a second, unwanted VERTICAL scrollbar — horizontal-only scrolling.
    // Tab bars that already fit are visually unchanged (no scrollbar appears when
    // content fits). Alignment is left to callers so centered tab bars keep their look.
    className={cn(
      "inline-flex h-9 max-w-full items-center justify-center overflow-x-auto overflow-y-hidden rounded-lg bg-muted p-1 text-muted-foreground",
      className
    )}
    {...props} />
))
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow",
      className
    )}
    {...props} />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className
    )}
    {...props} />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsList, TabsTrigger, TabsContent }
